import { httpClient } from "@bw/shared/api";

export type PlatformCoachExperienceClaim = {
  claim_id: string; coach_profile_id: string; source_org_id: string;
  coach_display_name: string; status: "pending_club" | "approved" | "rejected" | "platform_review";
  claimant_display_name: string; identity_proof_kind: "firebase_verified_email" | "platform_recovery";
  identity_proof_checked_at: string;
  visibility: "private" | "shared_clubs"; revision: number;
  created_at: string; resolved_at: string | null;
};
export const coachExperienceOperationsApi = {
  list: () => httpClient.get<PlatformCoachExperienceClaim[]>("/coach-experience/platform/claims?status=platform_review"),
  resolve: (claim: PlatformCoachExperienceClaim, decision: "approve" | "reject" | "return_to_club", reason: string) =>
    httpClient.post<PlatformCoachExperienceClaim>(`/coach-experience/platform/claims/${encodeURIComponent(claim.claim_id)}/resolution`, {
      decision, reason, expected_revision: claim.revision, idempotency_key: crypto.randomUUID(),
    }),
};
